import axios from "axios";
import { Response } from "@/shared/models/Response";
import { CupsPriceLevel } from "../models/CupsPriceLevel";
import { CupsPriceLevelPagination } from "../models/CupsPriceLevelPagination";
import { CupsPriceLevelHeader } from "../models/CupsPriceLevelHeader";
import { CupsPriceLevelFilter } from "../models/CupsPriceLevelFilter.model";
import { CupsPriceLevelCharts } from "../models/CupsPriceLevelCharts.model";

export class CupsPriceLevelService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_FORMS_API}/cups-price-levels`;
  }

  async getCupsPriceLevelById(
    id: string
  ): Promise<Response<CupsPriceLevel | void>> {
    const serviceUrl = `${this.baseUrl}/${id}`;
    const response = await axios.get(serviceUrl);
    return response.data;
  }

  async getCupsPriceLevelByFilter(
    query: CupsPriceLevelFilter
  ): Promise<Response<CupsPriceLevelPagination>> {
    const serviceURL = `${this.baseUrl}/find-by-filters`;
    const response = await axios.get(serviceURL, { params: query });
    return response.data;
  }

  async updateStateCupsPriceLevelById(
    id: string,
    state: string
  ): Promise<Response<void>> {
    const serviceUrl = `${this.baseUrl}/state/${id}/${state}`;
    const response = await axios.put(serviceUrl);
    return response.data;
  }

  async addCupsPriceLevel(
    cupsPriceLevel: CupsPriceLevel
  ): Promise<Response<string | void>> {
    const serviceUrl = `${this.baseUrl}/add-cups-price-lvl`;
    const response = await axios.post(serviceUrl, cupsPriceLevel);
    return response.data;
  }

  async checkIfCupsPriceLevelExists(cups: string): Promise<Response<void>> {
    cups;
    const serviceUrl = `${this.baseUrl}/price-level-by-cups`;
    const response = await axios.get(serviceUrl, { params: { cups } });
    return response.data;
  }

  async checkIfExistByName(name: string): Promise<Response<void>> {
    const serviceURL = `${this.baseUrl}/exist-by-name`;

    const params = {
      params: {
        namePriceLevel: name
      }
    };

    const response = await axios.get(serviceURL, params);
    return response.data;
  }

  async updateCupsPriceLevel(
    id: string,
    cupsPriceLevel: CupsPriceLevel
  ): Promise<Response<void>> {
    const serviceUrl = `${this.baseUrl}/${id}`;
    const response = await axios.put(serviceUrl, cupsPriceLevel);
    return response.data;
  }

  async deleteCupsPriceLevel(id: string): Promise<Response<string | void>> {
    return (await axios.delete(`${this.baseUrl}/${id}`)).data;
  }

  async getAllActiveCupsPriceLevel(): Promise<
    Response<CupsPriceLevelHeader[]>
  > {
    const serviceURL = `${this.baseUrl}/get-all-active-cups`;
    const response = await axios.get(serviceURL);
    return response.data;
  }

  async getChart(
    query: CupsPriceLevelFilter
  ): Promise<Response<CupsPriceLevelCharts>> {
    const serviceURL = `${this.baseUrl}/charts`;
    const response = await axios.get(serviceURL, { params: query });
    return response.data;
  }
}
